// Rótulos de status/origem (inspection.md §6.2) — o i18n é a fonte do texto,
// este módulo só mapeia o valor do wire para a chave correta.

import type {
  InspectionCreationOrigin,
  InspectionStatus,
} from "../api/inspection";

export const inspectionStatusLabelKey = (status: InspectionStatus) =>
  `inspection.status.${status}`;

export const inspectionOriginLabelKey = (origin: InspectionCreationOrigin) =>
  `inspection.origin.${origin}`;

export const INSPECTION_STATUS_VALUES: InspectionStatus[] = [
  "open",
  "inProgress",
  "finalized",
  "notFinalized",
];

export const INSPECTION_ORIGIN_VALUES: InspectionCreationOrigin[] = [
  "scheduled",
  "manual",
];

/** Editar/preencher só antes da finalização (quality-test §3.4). */
export const isInspectionEditableStatus = (status: InspectionStatus) =>
  status === "open" || status === "inProgress";

/**
 * Soft delete é exclusivo de inspeção **manual em andamento** — programada,
 * `Aberta`, finalizada e `Não finalizada` nunca podem ser deletadas
 * (quality-test `QT-INSP-11-02`).
 */
export const isInspectionDeletable = (
  status: InspectionStatus,
  origin: InspectionCreationOrigin,
) => status === "inProgress" && origin === "manual";
